import { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import Logo from "../src/image/logo.png";
import { persistor, store } from "./redux/Store/store";
import RouteComponent from "./Routes/routes";

function App() {
  const [faviconUrl, setFaviconUrl] = useState(Logo);

  useEffect(() => {
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.rel = "icon";
    link.href = faviconUrl;
    document.head.appendChild(link);
  }, [faviconUrl]);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <RouteComponent />
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
